import React from "react";
import { useGame } from "@/context/GameContext";
import Avatar from "@/components/avatar/Avatar";

const SIZES = {
  sm: { box: "w-8 h-8 text-lg rounded-lg", av: 30, name: "text-xs" },
  md: { box: "w-12 h-12 text-2xl rounded-xl", av: 44, name: "text-sm" },
  lg: { box: "w-20 h-20 text-5xl rounded-2xl", av: 74, name: "text-xl" },
};

// Logo tile (+ optional name) for a business brand
const BrandBadge = ({ brand, biz, size = "md", showName = true, className = "", testid = "brand-badge" }) => {
  const { state } = useGame();
  const s = SIZES[size];
  const color = brand.color || biz.primary;
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid={testid}>
      <div
        className={`${s.box} shrink-0 flex items-center justify-center overflow-hidden border-b-4 border-black/20 text-white`}
        style={{ backgroundColor: color }}
        data-testid={`${testid}-logo`}
      >
        {brand.logo === "avatar" ? (
          <Avatar avatar={state.avatar} size={s.av} className="translate-y-1" testid={`${testid}-avatar`} />
        ) : (
          <span>{brand.logo}</span>
        )}
      </div>
      {showName && (
        <span className={`font-display font-bold ${s.name} text-slate-900 leading-tight break-words`} data-testid={`${testid}-name`}>
          {brand.name}
        </span>
      )}
    </div>
  );
};

export default BrandBadge;
